import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  exportToExcelMedicalSuplies,
  getMedicalSupliesAction,
} from "../../Actions/MedicalSupliesAction/MedicalSupliesAction";

import { CiFilter } from "react-icons/ci";
import { IoCheckmark } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import ReactPaginate from "react-paginate";
import { IoIosArrowBack } from "react-icons/io";
import { getTypeOfHeAction } from "../../Actions/SurgeryAction/TypeOfHelpAction";
import { RiFileExcel2Fill } from "react-icons/ri";
import LoadingPage from "../Loading/LoadingPage";
import Pagination from "../Pagination";

const MedicalSupliesPage = () => {
  const getMedicalSuplies = useSelector((state) => state.getMedicalSuplies);
  const { medicalSuplies, loading, total } = getMedicalSuplies;
  const branchId = localStorage.getItem("branch_id");
  useEffect(() => {
    dispatch(getTypeOfHeAction());
  }, []);
  const getTypeOfHelp = useSelector((state) => state.getTypeOfHelp);
  const { typeOfHelps } = getTypeOfHelp;
  const th = [
    {
      label: "Code",
      name: "code",
    },
    {
      label: "full Name",
      name: "fullname",
    },
    {
      label: "type of help",
      name: "typeOfHelp",
    },
    {
      label: "City",
      name: "city",
    },
    {
      label: "hospital",
      name: "hospital",
    },
    {
      label: "type Of Test",
      name: "typeOfTest",
    },
    {
      label: "total",
      name: "total",
    },
    {
      label: "date",
      name: "date",
    },
  ];
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [indexx, setIndexx] = useState(null);
  const dispatch = useDispatch();

  const onPageChange = (event) => {
    setPage(event.selected);
    dispatch(
      getMedicalSupliesAction(
        branchId,
        perPage,
        event.selected + 1,
        filter.fullname,
        filter.code,
        filter.typeOfHelp,
        filter.city,
        filter.hospital,
        filter.typeOfTest,
        filter.total,
        filter.date,
        filter.from,
        filter.to
      )
    );
  };
  const [filter, setFilter] = useState({
    fullname: "",
    code: "",
    typeOfHelp: "",
    city: "",
    hospital: "",
    typeOfTest: "",
    total: "",
    date: "",
    from: "",
    to: "",
  });
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };
  const handleSearch = () => {
    dispatch(
      getMedicalSupliesAction(
        branchId,
        perPage,
        page,
        filter.fullname,
        filter.code,
        filter.typeOfHelp,
        filter.city,
        filter.hospital,
        filter.typeOfTest,
        filter.total,
        filter.date,
        filter.from,
        filter.to
      )
    );
    setIndexx(null);
  };
  const handleClearSearch = (name) => {
    const updateParam={...filter};
    updateParam[name]="";
    setFilter(updateParam)
    dispatch(
      getMedicalSupliesAction(
        branchId,
        perPage,
        page,
        updateParam.fullname,
        updateParam.code,
        updateParam.typeOfHelp,
        updateParam.city,
        updateParam.hospital,
        updateParam.typeOfTest,
        updateParam.total,
        updateParam.date,
        updateParam.from,
        updateParam.to
      )
    );
    setIndexx(null);
  };
  useEffect(() => {
    dispatch(
      getMedicalSupliesAction(
        branchId,
        perPage,
        page,
        filter.fullname,
        filter.code,
        filter.typeOfHelp,
        filter.city,
        filter.hospital,
        filter.typeOfTest,
        filter.total,
        filter.date,
        filter.from,
        filter.to
      )
    );
  }, [perPage, filter.typeOfHelp]);

  const handleExport = () => {
    exportToExcelMedicalSuplies(filter.from, filter.to);
  };
  return (
    <>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="parent">
          <div className="flex justify-between items-center p-2">
            <div className="flex gap-2 items-center">
              <input
                type="date"
                value={filter.from}
                name="from"
                className="input w-full"
                onChange={handleFilterChange}
              />
              To
              <input
                type="date"
                className="input w-full"
                value={filter.to}
                name="to"
                onChange={handleFilterChange}
              />
              <button
                className="btn-primary py-2 px-2.5"
                onClick={handleSearch}
              >
                {" "}
                <CiFilter />
              </button>
            </div>
            <button
              onClick={handleExport}
              className="btn-success p-1 items-center flex gap-2"
            >
              Export <RiFileExcel2Fill />
            </button>
          </div>

          <div className={"parent-table  w-full"}>
            <div className=" overflow-y-auto" style={{ height: "70vh" }}>
              <table className="w-full  overflow-y-auto">
                <thead className="coustm-thead">
                  <tr>
                    <th className="coustm-th">#</th>
                    {th.map((th, index) => {
                      return (
                        <th className="coustm-th relative " key={index}>
                          <div className="flex justify-between items-center">
                            {th.label}
                            <div
                              className="parent-filter"
                              onClick={() => {
                                setIsOpenFilter(!isOpenFilter);
                                setIndexx(index);
                              }}
                            >
                              <CiFilter />
                            </div>
                          </div>
                          {index == indexx && isOpenFilter && (
                            <div className="parent-input-filter ">
                              <input
                                type="text"
                                className="p-2 text-black"
                                name={th.name}
                                onChange={handleFilterChange}
                                value={filter[th.name]}
                                placeholder={th.label}
                              />
                              <div className="fotter-filter mt-2">
                                <button
                                  className="btn-primary px-1.5 py-1 font-bold"
                                  onClick={handleSearch}
                                >
                                  <IoCheckmark />
                                </button>
                                <button className="btn-danger px-1.5 py-1">
                                  <RxCross2 />
                                </button>
                              </div>
                            </div>
                          )}
                        </th>
                      );
                    })}
                  </tr>
                </thead>

                <tbody>
                  {medicalSuplies?.map((medical, index) => {
                    console.log("hospitals : ",medical?.hospitals)
                    return (
                      <tr className="coustm-tr" key={index}>
                        <td className="coustm-td">{index + 1}</td>
                        <td className="coustm-td">
                          {medical.visit?.patient?.patient_info?.code}
                        </td>
                        <td className="coustm-td">
                          {medical.visit?.patient?.patient_info?.fullname}
                        </td>
                        <td className="coustm-td">{medical.type_of_help}</td>
                        
                        <td className="coustm-td">{medical.place}</td>
                        <td className="coustm-td">{medical?.hospitals?.map((hospital) =>{
                          return (
                            <p>{hospital?.name}</p>
                          )
                        } )}</td>
                        <td className="coustm-td">{medical.type_of_test}</td>
                        <td className="coustm-td">{medical.cost}</td>
                        <td className="coustm-td">{medical.date}</td>

                        {/* <td className="coustm-td"></td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {total > 0 ? (
            <Pagination
              page={page}
              total={total}
              perPage={perPage}
              setPerPage={setPerPage}
              onPageChange={onPageChange}
            />
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
};

export default MedicalSupliesPage;
